import React from "react";
import translate from "../../../constants/translations";

interface NewMessageIndicatorProps {
	cultureCode: string;
	seenByCustomer: boolean;
}

export default function NewMessageIndicator({
	cultureCode,
	seenByCustomer,
}: NewMessageIndicatorProps) {
	if (!seenByCustomer) {
		return (
			<span className="mypages-insurance-field__new">
				{translate(cultureCode, "NewMessage")}
			</span>
		);
	}

	return null;
}
